import { render, staticRenderFns } from "./ShortsVideoPlayer.vue?vue&type=template&id=641bfb58&scoped=true"
import script from "./ShortsVideoPlayer.vue?vue&type=script&lang=js"
export * from "./ShortsVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./ShortsVideoPlayer.vue?vue&type=style&index=0&id=641bfb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641bfb58",
  null
  
)

export default component.exports